import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductArtwork } from './ProductArtwork';
import { PRODUCT_NAME } from './constants';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
const initialTime: TimeLeft = {
  hours: 1,
  minutes: 30,
  seconds: 5
};
function ClockUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div data-id="element-125" data-mp="icyhiprni3hs">
      <div className="rounded-md bg-navy px-2.5 py-1.5 font-mono text-lg font-bold text-white" data-id="element-126" data-mp="ifkrew20kv36">
        {String(value).padStart(2, '0')}
      </div>
      <p className="mt-0.5 text-[9px] font-bold tracking-wider text-muted" data-id="element-127" data-mp="rey3lwhivxrl">
        {label}
      </p>
    </div>;
}
export function OfferSection() {
  const [time, setTime] = useState(initialTime);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setTime(current => {
        const total = current.hours * 3600 + current.minutes * 60 + current.seconds;
        const next = total === 0 ? 5405 : total - 1;
        return {
          hours: Math.floor(next / 3600),
          minutes: Math.floor(next % 3600 / 60),
          seconds: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <section className="border-y border-sport/30 bg-canvas px-4 py-6 sm:py-8" data-id="element-128" data-mp="ownayrvissyv">
      <div className="mx-auto max-w-xl text-center" data-id="element-129" data-mp="1lme3ilk94621">
        <p className="text-xs font-display font-bold uppercase tracking-widest text-electric" data-id="element-130" data-mp="1ll2yyjizeu9v">
          SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
        </p>
        <h2 className="mt-1 text-xl font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-131" data-mp="1clfzi39tbyjg">
          Get instant access today and completely transform the way you plan and
          coach athletic performance.
        </h2>
        <div className="mt-3 inline-block rounded-md bg-navy px-3 py-1.5 font-display text-xs font-bold text-white" data-id="element-132" data-mp="17kn32aam3vx">
          💪 {PRODUCT_NAME} — Complete 6-in-1 Planning System for Strength &amp;
          Conditioning Coaches
        </div>
        <ProductArtwork className="mx-auto my-3 max-w-xs drop-shadow-xl" data-id="element-133" data-mp="3ts6korfltqf5" />

        <div className="rounded-xl border-4 border-sport bg-white p-4 shadow-xl sm:p-5" data-id="element-134" data-mp="2n6j4ix0bb94">
          <p className="text-sm font-semibold text-graphite" data-id="element-135" data-mp="3ksrult3cnhv6">
            Regular Price: <span className="line-through" data-id="element-136" data-mp="3ou4yvyqsnczz">$97</span>
          </p>
          <p className="mt-1 text-sm font-display font-bold uppercase text-sport" data-id="element-137" data-mp="3b3i3afgby384">
            🔥 72% OFF — LIMITED-TIME LAUNCH OFFER
          </p>
          <p className="mt-1 font-display text-5xl font-extrabold text-navy" data-id="element-138" data-mp="3fv02oz2pfvqz">
            Today Only: $27 USD
          </p>
          <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-muted" data-id="element-139" data-mp="31391mm3kjplc">
            Pay securely in your local currency.
          </p>

          <div className="my-4 rounded-lg border border-electric/25 bg-electric/5 p-3" data-id="element-140" data-mp="2s4du96osg9gg">
            <p className="text-xs font-display font-bold uppercase text-navy" data-id="element-141" data-mp="2x48mpeo7p73m">
              🔥 Last Chance! This special price expires when the countdown
              reaches zero.
            </p>
            <div className="mt-2 flex items-start justify-center gap-2" data-id="element-142" data-mp="28jdnn1vmlzvj">
              <ClockUnit value={time.hours} label="HOURS" data-id="element-143" data-mp="28l6tieyf0g2h" />
              <span className="pt-1 text-lg font-bold text-muted" data-id="element-144" data-mp="2mjes0rb3npfr">:</span>
              <ClockUnit value={time.minutes} label="MINUTES" data-id="element-145" data-mp="2igs2wy5tcim9" />
              <span className="pt-1 text-lg font-bold text-muted" data-id="element-146" data-mp="2ije7qq1bkk0s">:</span>
              <ClockUnit value={time.seconds} label="SECONDS" data-id="element-147" data-mp="2weyk12mjm3z8" />
            </div>
          </div>

          <CTAButton className="!bg-sport !shadow-sport/25 hover:!bg-[#e37835]" data-id="element-148" data-mp="2rhg7l29bh6mh">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>
        </div>

        <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs font-bold text-navy" data-id="element-149" data-mp="318kkzxjcgjf7">
          <span className="inline-flex items-center gap-1" data-id="element-150" data-mp="3f82egq7l4kuw">
            <StarIcon className="h-4 w-4 fill-sport text-sport" aria-hidden="true" data-id="element-151" data-mp="3a8hhglbz6mkt" />
            4.9/5 — Verified Coach Reviews
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-152" data-mp="18h7f940cs5g2">
            <ShieldCheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-153" data-mp="1dgk41uasbmla" />
            7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}